import { Card } from '../components/Card'
import { SimpleLayout } from '../components/SimpleLayout'
import licketyScript from '/images/logos/lickety-script.png'
import shebangSquare from '/images/logos/shebang-square.png'
import tenRules from '/images/logos/10-rules.png'
import { Container } from '../components/Container'

import portraitImage from '/images/portrait.jpg'
import {Helmet} from "react-helmet-async";
import {Header} from "../components/Header.jsx";
import {Footer} from "../components/Footer.jsx";

export const metadata = {
    title: 'Creations',
    description: 'Things I’ve made.',
}

const projects = [
    {
        name: 'Bash Script Templates & Snippets',
        description:
            'Leitz\'s Bash Script Templates & Snippets contains all the tips and tricks I\'ve used over the past 25 years creating Bash scripts.  These are simple to use templates and examples that get you up and running quickly.  Tame the wild west that is Bash scripting into useable functions and easy to understand processing.',
        link: { href: 'https://bashswipe.com', label: 'Bash Script Templates & Snippets' },
        logo: shebangSquare,
    },
    {
        name: '10 Rules for Devs',
        description:
            'The mistakes that took me decades to learn, you can learn in minutes. The 10 crucial rules of software development.',
        link: { href: 'https://get.10rulesfordevs.com', label: '10rulesfordevs.com' },
        logo: tenRules,
    },
    {
        name: 'Lickety Script',
        description:
            'Lickety Script is a free web based tool to help you create Bash scripts quickly. Specify inputs with their validations, help text, switches, and more. Get up your Bash script up and running in seconds!',
        link: { href: 'https://licketyscript.app', label: 'licketyscript.app' },
        logo: licketyScript,
    }
]

function LinkIcon(props) {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
            <path
                d="M15.712 11.823a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm-4.95 1.768a.75.75 0 0 0 1.06-1.06l-1.06 1.06Zm-2.475-1.414a.75.75 0 1 0-1.06-1.06l1.06 1.06Zm4.95-1.768a.75.75 0 1 0-1.06 1.06l1.06-1.06Zm3.359.53-.884.884 1.06 1.06.885-.883-1.061-1.06Zm-4.95-2.12 1.414-1.415L12 6.344l-1.415 1.413 1.061 1.061Zm0 3.535a2.5 2.5 0 0 1 0-3.536l-1.06-1.06a4 4 0 0 0 0 5.656l1.06-1.06Zm4.95-4.95a2.5 2.5 0 0 1 0 3.535L17.656 12a4 4 0 0 0 0-5.657l-1.06 1.06Zm1.06-1.06a4 4 0 0 0-5.656 0l1.06 1.06a2.5 2.5 0 0 1 3.536 0l1.06-1.06Zm-7.07 7.07.176.177 1.06-1.06-.176-.177-1.06 1.06Zm-3.183-.353.884-.884-1.06-1.06-.884.883 1.06 1.06Zm4.95 2.121-1.414 1.414 1.06 1.06 1.415-1.413-1.06-1.061Zm0-3.536a2.5 2.5 0 0 1 0 3.536l1.06 1.06a4 4 0 0 0 0-5.656l-1.06 1.06Zm-4.95 4.95a2.5 2.5 0 0 1 0-3.535L6.344 12a4 4 0 0 0 0 5.656l1.06-1.06Zm-1.06 1.06a4 4 0 0 0 5.657 0l-1.061-1.06a2.5 2.5 0 0 1-3.535 0l-1.061 1.06Zm7.07-7.07-.176-.177-1.06 1.06.176.178 1.06-1.061Z"
                fill="currentColor"
            />
        </svg>
    )
}

export default function Creations() {
    return (
        <div>
            <Helmet>
                <title>Michael Leitz</title>
                <meta name="description"
                      content="I'm Leitz, a software guy who's done every job in tech. Based in Nashville, TN. I help people understand the tech world by sharing wisdom acquired in my 25 years of professional delopment experience."/>
                <meta property="og:title" content="Leitz - Home"/>
                <meta
                    property="og:description"
                    content="Personal site of Michael Leitz, prolific software developer and manager"
                />
                <meta property="og:image" content="/images/portrait.jpg"/>
                <meta property="og:type" content="website"/>
            </Helmet>
            <Header />
            <main className="main flex flex-col items-center">
                <Container className="mt-1">
                    <SimpleLayout
                        title="Things I’ve made."
                        intro="Projects that I created using my experience and passion for the software business."
                    >
                        <ul
                            role="list"
                            className="grid grid-cols-1 gap-x-12 gap-y-16 sm:grid-cols-2 lg:grid-cols-3"
                        >
                            {projects.map((project) => (
                                <Card as="li" key={project.name}>
                                    <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-md shadow-zinc-800/5 ring-1 ring-zinc-900/5 dark:border dark:border-zinc-700/50 dark:bg-zinc-800 dark:ring-0">
                                        <img
                                            src={project.logo}
                                            alt=""
                                            className="h-8 w-8"
                                        />
                                    </div>
                                    <h2 className="mt-6 text-base font-semibold text-zinc-800 dark:text-zinc-100">
                                        <Card.Link href={project.link.href}>{project.name}</Card.Link>
                                    </h2>
                                    <Card.Description>{project.description}</Card.Description>
                                    <p className="relative z-10 mt-6 flex text-sm font-medium text-zinc-400 transition group-hover:text-teal-500 dark:text-zinc-200">
                                        <LinkIcon className="h-6 w-6 flex-none" />
                                        <span className="ml-2">{project.link.label}</span>
                                    </p>
                                </Card>
                            ))}
                        </ul>
                    </SimpleLayout>

                </Container>
            </main>
            <Footer />
        </div>
    )
}
